<div class="item-row mat-elevation-z1">
  <div class="item-cell thumbnail-container item-cell-fist">
    <div *ngIf="data.thumbnail; else svgThumbnail" class="thumbnail-image">
      <img [src]="data.thumbnail" />
      <mat-icon class="thumbnail-icon" svgIcon="{{ data.thumbnailIcon }}"></mat-icon>
    </div>
    <ng-template #svgThumbnail>
      <div class="svg-thumbnail">
        <mat-icon svgIcon="{{ data.thumbnailSVG }}"></mat-icon>
      </div>
    </ng-template>
  </div>
  <div class="item-cell title-container">
      <div class="title">
        <span class="title-label">{{ data.label }}</span>
      </div>
  </div>
  <div class="item-cell gauge-container" matTooltip="Percentage of visitors who interacted with this annotation">
    <mwl-gauge
      [dialStartAngle]="-90"
      [dialEndAngle]="-90.001"
      [max]="100"
      [value]="data.userPercentage || 0"
      [label]="getLabel.bind(this)"
    >
    </mwl-gauge>
  </div>
</div>
